import { render, staticRenderFns } from "./OCT.vue?vue&type=template&id=c8be6840&scoped=true&"
import script from "./OCT.vue?vue&type=script&lang=js&"
export * from "./OCT.vue?vue&type=script&lang=js&"
import style0 from "./OCT.vue?vue&type=style&index=0&id=c8be6840&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8be6840",
  null
  
)

export default component.exports